import {ChangeDetectorRef, Component, ViewEncapsulation} from '@angular/core';
import {CmsComponentData} from '@spartacus/storefront';
import {CmsBannerComponent} from '@spartacus/core';
import {UntilDestroy} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'dcp-sap-logo',
  templateUrl: './sap-logo.component.html',
  styleUrls: ['./sap-logo.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SapLogoComponent {

  constructor(
    public component: CmsComponentData<CmsBannerComponent>,
    protected cdr: ChangeDetectorRef,
  ) {
  }

  isExternalLink(external: string | boolean) {
    return external === true || external === 'true';
  }
}
